import React, { type ComponentProps, lazy, Suspense, type ReactNode, type ComponentType } from 'react';

import { AppLoader } from '../shared/Loaders/Loader';

import styles from './LazyReact.module.css';

interface LazyLoaderProps {
  readonly children: ReactNode;
  readonly floatingLoader?: boolean;
}

export const LazyReact = ({ children, floatingLoader }: LazyLoaderProps) => (
  <Suspense fallback={<AppLoader className={floatingLoader ? styles.floatingLoader : ''} />}>{children}</Suspense>
);

/**
 * Lazyload a React component from its path
 * and wrap it with its own Suspense parent.
 *
 * @param load Callback that should return the promise of the imported module.
 * @returns
 */
export const lazyWithSuspense = <T extends ComponentType<any>>(load: () => Promise<{ default: T }>, floatingLoader?: boolean) => {
  const LazyComponent = lazy(load);

  return (props: ComponentProps<T>) => (
    <LazyReact floatingLoader={floatingLoader}>
      <LazyComponent {...props} />
    </LazyReact>
  );
};
